import XLSX from "xlsx";

(()=>{
  "use strict";

  var saveTranslation = (data_translated) => {
    let header_id = $("#info_header").data('id');

    document.getElementById("init_translate").disabled = true;
    document.getElementById("init_translate").innerHTML = `<i class="fas fa-spinner fa-pulse fa-2x"></i>`;

    fetch(`/survey_headers/${header_id}/survey_bodies/load_translation`, {
      method: "POST",
      headers: new Headers({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].attributes['content'].value
      }),
      body: JSON.stringify(data_translated)
    })
    .then(response => { 
      return response.json(); 
    })
    .catch(error => {
      console.log(error);
    })
    .then(data => {
      document.getElementById("init_translate").disabled = false;
      document.getElementById("init_translate").innerHTML = `<span class="fa-2x">Cargar Traducción</span>`;
      swal("Proceso de carga terminado");
    });
  };

  var formatData = (sheet_data) => {
    let json = JSON.parse(sheet_data),
        info = { translations: [] };

    if (json != undefined) {
      json.forEach(row => {
        info.translations.push(
          {
            id: row.body_id,
            survey_body: {
              survey_body_transls_attributes: [
                {
                  id: row.main_id || null, 
                  language_id: row.main_lang_id, 
                  question: row.Base.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ0-9\.,;¿?¡!-_<>= ]/g, '')
                },
                {
                  id: row.trans_id || null, 
                  language_id: row.trans_lang_id, 
                  question: row.Translate.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ0-9\.,;¿?¡!-_<>= ]/g, '')
                }
              ]
            }
          }
        );
      });

      saveTranslation(info);
    }
  };

  var readFile = () => {
    let file = document.getElementById("file_translate").files[0],
        reader = new FileReader();
    
    if (file) {
      reader.onload = (e) => {
        let data = e.target.result,
            workbook = XLSX.read(data, { type: 'binary' });
  
        workbook.SheetNames.forEach(sheet => {
          let rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]),
              jsonObject = JSON.stringify(rowObject);
          
          formatData(jsonObject);
        });
      };
  
      reader.readAsBinaryString(file);
    } else {
      swal('Debe Seleccionar un archivo valido')
    }
  };

  var getOtherLanguages = (element) => {
    document.getElementById("translation_language").disabled = true;
    
    fetch(`/parameterization/languages.json?language[id]=${document.getElementById("main_language").value}`, {
      method: "GET"
    })
    .then(response => { 
      return response.json(); 
    })
    .then(data => {
      let new_options = '';

      data.forEach(e => {
        new_options += `<option value="${e.id}">${e.language}</option>`;
      });

      document.getElementById("translation_language").innerHTML = new_options;
      document.getElementById("translation_language").disabled = false;
    });
  };

  document.addEventListener('turbolinks:load', () => {
    if ($("#main_language").length > 0) {
      getOtherLanguages();

      $("#main_language").change(getOtherLanguages);

      $("#init_translate").click(readFile);
    }
  });
})();